/** @format */

import {
	ChangeDetectionStrategy,
	Component,
	HostListener,
	Inject,
	input,
	OnInit,
	signal
} from '@angular/core';
import { ProductAnalyticsService } from '@shared/data-access/analytics';
import { WINDOW } from '@shared/data-access/services';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { NgClass } from '@angular/common';

@Component({
	selector: 'pdp-feature-change-store-button',
	styleUrl: './change-store-button.component.scss',
	templateUrl: './change-store-button.component.html',
	imports: [HmfActionTextComponent, NgClass],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeStoreButtonComponent implements OnInit {
	/** @description Resolved sku part number or selected bundle part numbers */
	readonly resolvedSkuId = input<string | string[]>();

	/** @description Array of all sku part numbers */
	readonly productSkusPartNumber = input<string[]>();

	readonly isSubtext = input(false);

	readonly isDisabled = input(false);

	readonly dataEm = input('');

	readonly storeSelectionReady = signal(false);

	ngOnInit() {
		if (window.headerFunctions?.storeSelection) {
			this.storeSelectionReady.set(true);
		}
	}

	constructor(
		@Inject(WINDOW) protected window: Window,
		private productAnalyticsService: ProductAnalyticsService
	) {}

	/**
	 * @description look to see if there is a resolved sku,
	 * if there is need to pass an array of all the sku part numbers as well as the resolved sku part number,
	 * if sku is not resolved, pass an array of all the sku part numbers
	 */
	openChangeStorePanel() {
		const storeSelectionValues = this.resolvedSkuId()
			? { skusArr: this.productSkusPartNumber(), selectedSkuVal: this.resolvedSkuId() }
			: { skusArr: this.productSkusPartNumber() };
		if (window.headerFunctions?.storeSelection) {
			this.window.headerFunctions.storeSelection(storeSelectionValues);
		}
		const dataEmValue = this.dataEm();
		if (dataEmValue) {
			this.productAnalyticsService.triggerDataEmCall(dataEmValue);
		}
	}

	@HostListener('window:HeaderServices:StoreSelection:Ready', ['$event'])
	public onStoreSelectionReady(customEvent: CustomEvent): void {
		if (customEvent) {
			this.storeSelectionReady.set(true);
		}
	}
}
